const theme = {
  fonts: {
    primaryFontBold: "Roboto, sans-serif",
    primaryFontBoldItalic: "Roboto, sans-serif",
    primaryFontCondLight: "Roboto, sans-serif",
    primaryFontCondLightItalic: "Roboto, sans-serif",
    primaryFontExtraBold: "Roboto, sans-serif",
    primaryFontExtraBoldItalic: "Roboto, sans-serif",
    primaryFontItalic: "Roboto, sans-serif",
    primaryFontLight: "Roboto, sans-serif",
    primaryFontLightItalic: "Roboto, sans-serif",
    primaryFontRegular: "Roboto, sans-serif",
    primaryFontSemiBold: "Roboto, sans-serif",
    interRegular: "Roboto, sans-serif",
    interSemiBold: "Roboto, sans-serif",
    interLight: "Roboto, sans-serif",
    interBold: "Roboto, sans-serif",
    latoFont: "Roboto, sans-serif",
  },
  breakpoints: {
    xs: "(max-width: 575px)",
    sm_only: "(min-width: 576px) and (max-width: 768px)",
    md_only: "(min-width: 769px) and (max-width: 1024px)",
    lg_only: "(min-width: 1025px) and (max-width: 1199px)",
    xl: "(min-width: 1200px)",

    sm_up: "(min-width: 640px)",
    md_up: "(min-width: 769px)",
    lg_up: "(min-width: 1025px)",
    lg_plus_up: "(min-width: 1090px)",
    xl_up: "(min-width: 1200px)",
    xxl_up: "(min-width: 1440px)",

    xs_down: "(max-width: 575px)",
    sm_down: "(max-width: 768px)",
    md_down: "(max-width: 1024px)",
    lg_down: "(max-width: 1199px)",
    xl_down: "(max-width: 1200px)",
    xxl_down: "(max-width: 1439px)",

    //material breakpoints
    mat_md_down: "(max-width: 960px)",
    mat_sm_only: "(min-width: 575px) and (max-width: 960px)",
    mat_md_only: "(min-width: 960px) and (max-width: 1024px)",
    mat_xs_down: "(max-width: 600px)",
  },
};

export default theme;
